var parseDigits = function parseDigits(string) {
  return (string.match(/\d+/g) || []).join('');
};
export default parseDigits;